export const SECRET_IMAGE_EASTER_EGG_SEQUENCE =
  'i m a i up up down down left right left right b a enter';

export const SECRET_IMAGE_EASTER_EGG_SOURCES = [
  '/test/test.jpeg',
  '/test/test.png',
] as const;
